module.exports = __webpack_public_path__ + "media/assets/images/wallpapers/disenia_wallpaper-b94aed538bdd222e23da155f261c4c3b.jpg";